require('jquery-deparam/jquery-deparam');

var Marionette = require('backbone.marionette');

var DocumentsListView = require('./documents-list-view');
var ReviewElementStatusesModel = require('../../models/review-element-statuses-model');
var Pager = require('../pager/pager-view.js');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var CommonUtils = require('../../utils/common-utils.js');
var PasswordConfirmation = require('./password-confirmation');
var AssignAndUpdateReviewersForm = require('./assign-update-reviewers-form');
var AssignPatientForm = require("./assign-patient-form");
var SetDocumentDueForm = require("./set-document-due-form");
var AddCommentsForm = require("./add-comment-form");
var SendDocumentForm = require("./send-document-form");
var AddAddendumForm = require("./add-addendum-form");
var MarkAsForm = require("./mark-as-form");
var ExportDocumentForm = require("./export-document-form");
var OkDialogModal = require('../common/ok-message-dialog-with-action');


var Documents = Marionette.View.extend({
    template: require('../../templates/documents/documents.html'),

    regions: {
        documents: '#documents',
        pager: '#pager',
        passwordConfirmationDiv: '.password-confirmation-div',
        assignReviewersFormRegion: '#assign-reviewers-form',
        addPatientFormModal: '#add-patient-form-modal',
        sendFormModal: '#send-form-modal',
        addPatientWarning: '#add-patient-warning',
        setDueFormModal: '#set-due-form-modal',
        addCommentsFormModal: '#add-comment-form-modal',
        addAddendumFormModal: '#add-addendum-form-modal',
        markAsModal: '#mark-as-modal',
        exportFormModal: '#export-modal'
    },

    ui: {
        count: '#count'
    },

    events: {},

    childViewEvents: {
        'document:will-be-remove': 'removeDocument',
        'document:list:refresh': 'documentListRefresh',
        'document:reviewers:add:or:update': 'addOrUpdateReviewers',
        'document:patient:add': 'addPatient',
        'sign:documents': 'signDocuments',
        'reviewers:added:to:document': 'onReviewersAdded',
        'patient:added:to:document': 'onPatientAdded',
        'comment:added:to:document': 'onCommentAdded',
        'sent:document': 'onDocumentSent',
        'document:due:set': 'setDueDate',
        'document:comment': 'onDocumentComment',
        'document:send': 'onDocumentSend',
        'document:add:addendum': 'onAddAddendum',
        'due:set:to:document': 'onDueSet',
        'addendum:added:to:document': 'onAddendumAdded',
        'pager:count:change': 'countChange',
        'document:mark:as': 'onDocumentMarkAs',
        'document:export': 'onDocumentExport'
    },

    utils: new CommonUtils(),

    initialize: function (options) {
        this.reviewElementStatuses = new ReviewElementStatusesModel();
        this.params = $.deparam(window.location.hash.replace('#documents', '').replace('?', ''));
        this.docsCount = 0;

        this.signDocsCallbackForPager = {
            signDocuments: null
        }

    },

    onRender: function () {
        window.document.title = "RNS Documents";
        var that = this;
        $.when(that.reviewElementStatuses.fetch()
        ).then(function () {
            that.documentListRefresh();
        });
    },

    renderPager: function () {
        var that = this;
        that.showChildView('pager', new Pager({
            baseCountUrl: '/api/document/count',
            callbackFunctions: that.signDocsCallbackForPager
        }));
    },

    showErrors: function (model, errors) {
        model.view.triggerMethod('server:error', errors.join('. \n'));
    },

    documentListRefresh: function () {
        var that = this;
        that.showChildView('documents', new DocumentsListView({
            collectionParams: that.utils.queryParamsToCollection(that.params),
            reviewElementStatuses: that.reviewElementStatuses,
            username: that.options.user.login,
            isMd: that.options.user.isMd,
            isOfficeAdministrator: that.options.user.isOfficeAdministrator,
            isMedicalDirector: that.options.user.isMedicalDirector,
            isManager: that.options.user.isManager,
            isAdmin: that.options.user.isAdmin,
            byAdmin: that.getOption('byAdmin'),

            signDocsCallbackForPager: that.signDocsCallbackForPager
        }));

        that.renderPager();
    },

    addOrUpdateReviewers: function (data) {
        var that = this;

        that.showChildView('assignReviewersFormRegion', new AssignAndUpdateReviewersForm({
            reviewersAndDocuments: data.reviewersAndDocuments,
            documentsIds: data.documentsIds,
            getReviewerName: data.getReviewerName,
            woResponseEvent: data.woResponseEvent
        }));
    },

    addPatient: function (data) {
        var that = this;
        that.showChildView('addPatientFormModal', new AssignPatientForm({
            docIds: data.docIds,
            woResponseEvent: data.woResponseEvent
        }));
    },

    setDueDate: function (data) {
        var that = this;
        that.showChildView('setDueFormModal', new SetDocumentDueForm({
            docIds: data.docIds,
            woResponseEvent: data.woResponseEvent
        }));
    },

    onDocumentComment: function (data) {
        var that = this;
        that.showChildView('addCommentsFormModal', new AddCommentsForm({
            docIds: data.docIds,
            allFiltered: data.allFiltered,
            params: data.params,
            docsCount: that.docsCount,
            woResponseEvent: data.woResponseEvent
        }));
    },

    onDocumentSend: function (data) {
        var that = this;
        that.showChildView('sendFormModal', new SendDocumentForm({
            docIds: data.docIds,
            allFiltered: data.allFiltered,
            params: data.params,
            docsCount: that.docsCount,
            woResponseEvent: data.woResponseEvent
        }));
    },

    onAddAddendum: function (data) {
        var that = this;
        that.showChildView('addAddendumFormModal', new AddAddendumForm({
            docIds: data.docIds,
            woResponseEvent: data.woResponseEvent
        }));
    },

    onDocumentMarkAs: function (data) {
        var that = this;
        that.showChildView('markAsModal', new MarkAsForm({
            docIds: data.docIds,
            mode: data.mode,
            woResponseEvent: data.woResponseEvent
        }));
    },

    onDocumentExport: function (data) {
        var that = this;
        that.showChildView('exportFormModal', new ExportDocumentForm({
            docIds: data.docIds,
            allFiltered: data.allFiltered,
            params: data.params,
            docsCount: that.docsCount,
            woResponseEvent: data.woResponseEvent
        }));
    },

    onReviewersAdded: function () {
        this.documentListRefresh();
    },

    onPatientAdded: function (data) {
        this.documentListRefresh();
        if (data.documentsIdWithErrors && data.documentsIdWithErrors.length > 0) {
            var text = "The patient was not added to following documents - <br><ul>"
                + data.documentsIdWithErrors.map(function (docId) {
                    return '<li><a href="/#document/' + docId + '" target="_blank">' + docId + '</a></li>';
                }).join('') + "</ul><br> because update this documents is not allowed for you";

            this.showWarnings('Warning', text);
        }
    },

    onCommentAdded: function () {
        this.documentListRefresh();
    },

    onDocumentSent: function () {
        this.documentListRefresh();
    },

    onDueSet: function (data) {
        this.documentListRefresh();
        if (data.documentsIdWithErrors && data.documentsIdWithErrors.length > 0) {
            var text = "The due date was not setted to following documents - <br><ul>"
                + data.documentsIdWithErrors.map(function (docId) {
                    return '<li><a href="/#document/' + docId + '" target="_blank">' + docId + '</a></li>';
                }).join('') + "</ul><br> because update this documents is not allowed for you";

            this.showWarnings('Warning', text);
        }
    },

    onAddendumAdded: function () {
        this.documentListRefresh();
    },

    countChange: function (data) {
        this.docsCount = data;
        this.ui.count.html(data);
    },

    showWarnings: function (title, content) {

        this.addPatientWarningResultView = new OkDialogModal({
            title: title,
            message: content
        });

        this.showChildView('addPatientWarning', this.addPatientWarningResultView);
        this.addPatientWarningResultView.show();
    },

    signDocuments: function (data) {
        var passwordConfirmation = new PasswordConfirmation();
        this.showChildView('passwordConfirmationDiv', passwordConfirmation);
        passwordConfirmation.setIds(data.ids);
        passwordConfirmation.setAction(data.action);
        passwordConfirmation.setFn(data.fn);
        passwordConfirmation.showPasswordConfirmation();
        passwordConfirmation.setCancelAction(data.cancelAction);
    }
});

module.exports = Documents;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/documents.js
// module id = 299
// module chunks = 0